var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#00B8D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25C9.375 9.18187 11.0575 7.5 13.125 7.5C15.1925 7.5 16.875 9.18187 16.875 11.25C16.875 13.3181 15.1931 15 13.125 15C11.0569 15 9.375 13.3181 9.375 11.25ZM22.5 18.75C22.5 20.8212 20.8213 22.5 18.75 22.5C16.6788 22.5 15 20.8212 15 18.75C15 16.6788 16.6788 15 18.75 15C20.8213 15 22.5 16.6788 22.5 18.75ZM21.07 17.6863C20.8306 17.4369 20.4344 17.43 20.1863 17.6681L18.4906 19.3081C18.4013 19.3962 18.2538 19.3981 18.1644 19.3094L17.3181 18.4775C17.0706 18.235 16.6756 18.2394 16.4344 18.4862C16.1925 18.7331 16.1963 19.1281 16.4431 19.37L17.2894 20.2025C17.5769 20.4831 17.9531 20.6237 18.3288 20.6237C18.7044 20.6237 19.0794 20.4831 19.3619 20.2044L21.0513 18.5706C21.3 18.3312 21.3081 17.9356 21.0694 17.6869L21.07 17.6863ZM13.75 18.75C13.75 17.895 13.9656 17.0906 14.3438 16.3869C13.9506 16.2994 13.5438 16.25 13.125 16.25C10.0275 16.25 7.50625 18.7675 7.5 21.8644C7.49938 22.2125 7.77688 22.5 8.125 22.5H15.4506C14.41 21.5837 13.75 20.2456 13.75 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsssigned);
export default __webpack_public_path__ + "static/media/Asssigned.c062420ed1cd2cf553261f1a5d5223f0.svg";
export { ForwardRef as ReactComponent };